import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2d6aa799 = () => interopDefault(import('../../../src/pages/about-bambee/index.ts' /* webpackChunkName: "pages/about-bambee/index" */))
const _304b020c = () => interopDefault(import('../../../src/pages/about-bambee/index/audits.ts' /* webpackChunkName: "pages/about-bambee/index/audits" */))
const _407ac3f4 = () => interopDefault(import('../../../src/pages/about-bambee/index/document-retention.ts' /* webpackChunkName: "pages/about-bambee/index/document-retention" */))
const _9e49f5f8 = () => interopDefault(import('../../../src/pages/about-bambee/index/employee-feedback.ts' /* webpackChunkName: "pages/about-bambee/index/employee-feedback" */))
const _15560148 = () => interopDefault(import('../../../src/pages/about-bambee/index/hr-manager.ts' /* webpackChunkName: "pages/about-bambee/index/hr-manager" */))
const _e962bf40 = () => interopDefault(import('../../../src/pages/about-bambee/index/onboarding-termination.ts' /* webpackChunkName: "pages/about-bambee/index/onboarding-termination" */))
const _ac91c9ba = () => interopDefault(import('../../../src/pages/about-bambee/index/payment.vue' /* webpackChunkName: "pages/about-bambee/index/payment" */))
const _72de0ed4 = () => interopDefault(import('../../../src/pages/about-bambee/index/payment-confirm.vue' /* webpackChunkName: "pages/about-bambee/index/payment-confirm" */))
const _272b61c3 = () => interopDefault(import('../../../src/pages/about-bambee/index/payroll.ts' /* webpackChunkName: "pages/about-bambee/index/payroll" */))
const _6bb33162 = () => interopDefault(import('../../../src/pages/about-bambee/index/policies.ts' /* webpackChunkName: "pages/about-bambee/index/policies" */))
const _f8e114d0 = () => interopDefault(import('../../../src/pages/about-bambee/index/training.ts' /* webpackChunkName: "pages/about-bambee/index/training" */))
const _73454334 = () => interopDefault(import('../../../src/pages/about-bambee/index/welcome.ts' /* webpackChunkName: "pages/about-bambee/index/welcome" */))
const _460c8548 = () => interopDefault(import('../../../src/pages/activate-account.vue' /* webpackChunkName: "pages/activate-account" */))
const _2f78f74b = () => interopDefault(import('../../../src/pages/activation.vue' /* webpackChunkName: "pages/activation" */))
const _49459aba = () => interopDefault(import('../../../src/pages/activation-expired.vue' /* webpackChunkName: "pages/activation-expired" */))
const _5a7496e3 = () => interopDefault(import('../../../src/pages/add-worker/index.ts' /* webpackChunkName: "pages/add-worker/index" */))
const _7e46815e = () => interopDefault(import('../../../src/pages/benefits/index.ts' /* webpackChunkName: "pages/benefits/index" */))
const _17247924 = () => interopDefault(import('../../../src/pages/benefits/index/index.ts' /* webpackChunkName: "pages/benefits/index/index" */))
const _37f81396 = () => interopDefault(import('../../../src/pages/benefits/index/connect.ts' /* webpackChunkName: "pages/benefits/index/connect" */))
const _a57f1096 = () => interopDefault(import('../../../src/pages/benefits/index/manage.ts' /* webpackChunkName: "pages/benefits/index/manage" */))
const _0700a3c4 = () => interopDefault(import('../../../src/pages/benefits/index/shop.ts' /* webpackChunkName: "pages/benefits/index/shop" */))
const _35bb8f1c = () => interopDefault(import('../../../src/pages/ca-workplace-violence.vue' /* webpackChunkName: "pages/ca-workplace-violence" */))
const _281c911a = () => interopDefault(import('../../../src/pages/cabinet.vue' /* webpackChunkName: "pages/cabinet" */))
const _49d9eed2 = () => interopDefault(import('../../../src/pages/cabinet/active.vue' /* webpackChunkName: "pages/cabinet/active" */))
const _4fec144f = () => interopDefault(import('../../../src/pages/cabinet/CabinetImage.vue' /* webpackChunkName: "pages/cabinet/CabinetImage" */))
const _2d86db6a = () => interopDefault(import('../../../src/pages/cancellation/index.ts' /* webpackChunkName: "pages/cancellation/index" */))
const _128ea8c7 = () => interopDefault(import('../../../src/pages/cancellation/index/index.ts' /* webpackChunkName: "pages/cancellation/index/index" */))
const _922524a8 = () => interopDefault(import('../../../src/pages/cancellation/index/confirmation.ts' /* webpackChunkName: "pages/cancellation/index/confirmation" */))
const _9d67d704 = () => interopDefault(import('../../../src/pages/cancellation/index/extend-trial.ts' /* webpackChunkName: "pages/cancellation/index/extend-trial" */))
const _3be92bee = () => interopDefault(import('../../../src/pages/cancellation/index/offer-accepted.ts' /* webpackChunkName: "pages/cancellation/index/offer-accepted" */))
const _4792283d = () => interopDefault(import('../../../src/pages/cancellation/index/reason.ts' /* webpackChunkName: "pages/cancellation/index/reason" */))
const _aa5d926c = () => interopDefault(import('../../../src/pages/cancellation/index/reasons.ts' /* webpackChunkName: "pages/cancellation/index/reasons" */))
const _5974d704 = () => interopDefault(import('../../../src/pages/cancellation/index/save-account.ts' /* webpackChunkName: "pages/cancellation/index/save-account" */))
const _af72ee1e = () => interopDefault(import('../../../src/pages/cancellation/index/trial-extended.ts' /* webpackChunkName: "pages/cancellation/index/trial-extended" */))
const _76f0c7f2 = () => interopDefault(import('../../../src/pages/cancellation/index/offer/_id.ts' /* webpackChunkName: "pages/cancellation/index/offer/_id" */))
const _d8f3754c = () => interopDefault(import('../../../src/pages/company-setup/index.ts' /* webpackChunkName: "pages/company-setup/index" */))
const _4d6e3cd2 = () => interopDefault(import('../../../src/pages/conversations/index.ts' /* webpackChunkName: "pages/conversations/index" */))
const _5e38ed8a = () => interopDefault(import('../../../src/pages/customizing.ts' /* webpackChunkName: "pages/customizing" */))
const _01d5ce53 = () => interopDefault(import('../../../src/pages/dashboard/index.ts' /* webpackChunkName: "pages/dashboard/index" */))
const _8427ee20 = () => interopDefault(import('../../../src/pages/dashboard/index/index.ts' /* webpackChunkName: "pages/dashboard/index/index" */))
const _285dd423 = () => interopDefault(import('../../../src/pages/employee.vue' /* webpackChunkName: "pages/employee" */))
const _687b8669 = () => interopDefault(import('../../../src/pages/employee/index.js' /* webpackChunkName: "pages/employee/index" */))
const _534593b5 = () => interopDefault(import('../../../src/pages/employee/add.vue' /* webpackChunkName: "pages/employee/add" */))
const _21479182 = () => interopDefault(import('../../../src/pages/employee/bulk-add.vue' /* webpackChunkName: "pages/employee/bulk-add" */))
const _68b06eba = () => interopDefault(import('../../../src/pages/employee/create-job-description/_id.ts' /* webpackChunkName: "pages/employee/create-job-description/_id" */))
const _19b76dd4 = () => interopDefault(import('../../../src/pages/employee/edit/_id.ts' /* webpackChunkName: "pages/employee/edit/_id" */))
const _1bfd4f64 = () => interopDefault(import('../../../src/pages/employee/_id.vue' /* webpackChunkName: "pages/employee/_id" */))
const _0391ec51 = () => interopDefault(import('../../../src/pages/employee/_id/index.vue' /* webpackChunkName: "pages/employee/_id/index" */))
const _5d4ea604 = () => interopDefault(import('../../../src/pages/employee/_id/folders.vue' /* webpackChunkName: "pages/employee/_id/folders" */))
const _0347ec24 = () => interopDefault(import('../../../src/pages/employee/_id/job-description/index.vue' /* webpackChunkName: "pages/employee/_id/job-description/index" */))
const _04f5f943 = () => interopDefault(import('../../../src/pages/employee/_id/notes/index.vue' /* webpackChunkName: "pages/employee/_id/notes/index" */))
const _031ad7dd = () => interopDefault(import('../../../src/pages/employee/_id/profile.ts' /* webpackChunkName: "pages/employee/_id/profile" */))
const _fd678418 = () => interopDefault(import('../../../src/pages/employee/_id/settings.vue' /* webpackChunkName: "pages/employee/_id/settings" */))
const _45b997a9 = () => interopDefault(import('../../../src/pages/employee/_id/pip/_pip_id.vue' /* webpackChunkName: "pages/employee/_id/pip/_pip_id" */))
const _23b5fb6c = () => interopDefault(import('../../../src/pages/employee/_id/pip/_pip_id/index.vue' /* webpackChunkName: "pages/employee/_id/pip/_pip_id/index" */))
const _716c7152 = () => interopDefault(import('../../../src/pages/employee/_id/pip/_pip_id/documents.vue' /* webpackChunkName: "pages/employee/_id/pip/_pip_id/documents" */))
const _324f85ea = () => interopDefault(import('../../../src/pages/employee/_id/pip/_pip_id/duration.vue' /* webpackChunkName: "pages/employee/_id/pip/_pip_id/duration" */))
const _5ff1e14c = () => interopDefault(import('../../../src/pages/employee/_id/pip/_pip_id/goals.vue' /* webpackChunkName: "pages/employee/_id/pip/_pip_id/goals" */))
const _77e1a73e = () => interopDefault(import('../../../src/pages/employee/_id/pip/_pip_id/past-examples.vue' /* webpackChunkName: "pages/employee/_id/pip/_pip_id/past-examples" */))
const _9fe1da3c = () => interopDefault(import('../../../src/pages/employee/_id/pip/_pip_id/preview.vue' /* webpackChunkName: "pages/employee/_id/pip/_pip_id/preview" */))
const _2fe18b66 = () => interopDefault(import('../../../src/pages/employee/_id/verbal-warning/_verbal_id.vue' /* webpackChunkName: "pages/employee/_id/verbal-warning/_verbal_id" */))
const _2cd56d69 = () => interopDefault(import('../../../src/pages/employee/_id/verbal-warning/_verbal_id/index.vue' /* webpackChunkName: "pages/employee/_id/verbal-warning/_verbal_id/index" */))
const _0f192449 = () => interopDefault(import('../../../src/pages/employee/_id/verbal-warning/_verbal_id/consequences.vue' /* webpackChunkName: "pages/employee/_id/verbal-warning/_verbal_id/consequences" */))
const _21cc0cc2 = () => interopDefault(import('../../../src/pages/employee/_id/verbal-warning/_verbal_id/preview.vue' /* webpackChunkName: "pages/employee/_id/verbal-warning/_verbal_id/preview" */))
const _9cc9c810 = () => interopDefault(import('../../../src/pages/employee/_id/written-warning/_written_id.vue' /* webpackChunkName: "pages/employee/_id/written-warning/_written_id" */))
const _6c70c87b = () => interopDefault(import('../../../src/pages/employee/_id/written-warning/_written_id/index.vue' /* webpackChunkName: "pages/employee/_id/written-warning/_written_id/index" */))
const _73e690f7 = () => interopDefault(import('../../../src/pages/employee/_id/written-warning/_written_id/consequences.vue' /* webpackChunkName: "pages/employee/_id/written-warning/_written_id/consequences" */))
const _16cc1ee1 = () => interopDefault(import('../../../src/pages/employee/_id/written-warning/_written_id/documents.vue' /* webpackChunkName: "pages/employee/_id/written-warning/_written_id/documents" */))
const _18c1dc69 = () => interopDefault(import('../../../src/pages/employee/_id/written-warning/_written_id/goals.vue' /* webpackChunkName: "pages/employee/_id/written-warning/_written_id/goals" */))
const _956a4f9e = () => interopDefault(import('../../../src/pages/employee/_id/written-warning/_written_id/preview.vue' /* webpackChunkName: "pages/employee/_id/written-warning/_written_id/preview" */))
const _7302c5f2 = () => interopDefault(import('../../../src/pages/employee-review.vue' /* webpackChunkName: "pages/employee-review" */))
const _2ae8e216 = () => interopDefault(import('../../../src/pages/employee-review/index.vue' /* webpackChunkName: "pages/employee-review/index" */))
const _d403045a = () => interopDefault(import('../../../src/pages/employee-review/print/index.vue' /* webpackChunkName: "pages/employee-review/print/index" */))
const _2afd2eed = () => interopDefault(import('../../../src/pages/employee-review/sign/index.vue' /* webpackChunkName: "pages/employee-review/sign/index" */))
const _1eb04e0a = () => interopDefault(import('../../../src/pages/employee-review/print/_id.vue' /* webpackChunkName: "pages/employee-review/print/_id" */))
const _27f40895 = () => interopDefault(import('../../../src/pages/employee-review/sign/_id.vue' /* webpackChunkName: "pages/employee-review/sign/_id" */))
const _cbaa6ac6 = () => interopDefault(import('../../../src/pages/employee-review/_id.vue' /* webpackChunkName: "pages/employee-review/_id" */))
const _185001bb = () => interopDefault(import('../../../src/pages/employee-welcome/index.vue' /* webpackChunkName: "pages/employee-welcome/index" */))
const _6aa489a0 = () => interopDefault(import('../../../src/pages/errors.vue' /* webpackChunkName: "pages/errors" */))
const _6a5694c0 = () => interopDefault(import('../../../src/pages/forgot-password.vue' /* webpackChunkName: "pages/forgot-password" */))
const _0157dfc0 = () => interopDefault(import('../../../src/pages/get-bambee.vue' /* webpackChunkName: "pages/get-bambee" */))
const _1a9a4b1a = () => interopDefault(import('../../../src/pages/get-benefits/index.ts' /* webpackChunkName: "pages/get-benefits/index" */))
const _5c41f3e8 = () => interopDefault(import('../../../src/pages/get-payroll/index.vue' /* webpackChunkName: "pages/get-payroll/index" */))
const _5ae901ff = () => interopDefault(import('../../../src/pages/get-time-and-attendance/index.ts' /* webpackChunkName: "pages/get-time-and-attendance/index" */))
const _94dcbcf4 = () => interopDefault(import('../../../src/pages/get-training/index.js' /* webpackChunkName: "pages/get-training/index" */))
const _5631ad3a = () => interopDefault(import('../../../src/pages/get-training/index/index.js' /* webpackChunkName: "pages/get-training/index/index" */))
const _602ecb38 = () => interopDefault(import('../../../src/pages/get-training/index/confirmation.js' /* webpackChunkName: "pages/get-training/index/confirmation" */))
const _649b2a5a = () => interopDefault(import('../../../src/pages/goal/index.ts' /* webpackChunkName: "pages/goal/index" */))
const _08da2235 = () => interopDefault(import('../../../src/pages/guidance/index.ts' /* webpackChunkName: "pages/guidance/index" */))
const _6b33295c = () => interopDefault(import('../../../src/pages/guidance/index/index.ts' /* webpackChunkName: "pages/guidance/index/index" */))
const _754d4ab2 = () => interopDefault(import('../../../src/pages/hr-actions/index.vue' /* webpackChunkName: "pages/hr-actions/index" */))
const _1ad8ef00 = () => interopDefault(import('../../../src/pages/hr-intelligence/index.vue' /* webpackChunkName: "pages/hr-intelligence/index" */))
const _71817a08 = () => interopDefault(import('../../../src/pages/hr-practice/index.vue' /* webpackChunkName: "pages/hr-practice/index" */))
const _2ec1a0f8 = () => interopDefault(import('../../../src/pages/insurance/index.vue' /* webpackChunkName: "pages/insurance/index" */))
const _c061978a = () => interopDefault(import('../../../src/pages/job-description/index.ts' /* webpackChunkName: "pages/job-description/index" */))
const _261b18c4 = () => interopDefault(import('../../../src/pages/login.vue' /* webpackChunkName: "pages/login" */))
const _0f7afc47 = () => interopDefault(import('../../../src/pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _fd9b44a0 = () => interopDefault(import('../../../src/pages/login/forgot-pass.vue' /* webpackChunkName: "pages/login/forgot-pass" */))
const _eaedd37e = () => interopDefault(import('../../../src/pages/managed-services/index.ts' /* webpackChunkName: "pages/managed-services/index" */))
const _864db344 = () => interopDefault(import('../../../src/pages/managed-services/index/index.ts' /* webpackChunkName: "pages/managed-services/index/index" */))
const _29e42c3d = () => interopDefault(import('../../../src/pages/managed-services/index/explore.ts' /* webpackChunkName: "pages/managed-services/index/explore" */))
const _431809d4 = () => interopDefault(import('../../../src/pages/managed-services/index/_service.ts' /* webpackChunkName: "pages/managed-services/index/_service" */))
const _a454d016 = () => interopDefault(import('../../../src/pages/meetings/index.ts' /* webpackChunkName: "pages/meetings/index" */))
const _6b1bae0a = () => interopDefault(import('../../../src/pages/my-benefits/index.ts' /* webpackChunkName: "pages/my-benefits/index" */))
const _84b9f932 = () => interopDefault(import('../../../src/pages/my-benefits/index/index.ts' /* webpackChunkName: "pages/my-benefits/index/index" */))
const _357d8e20 = () => interopDefault(import('../../../src/pages/my-pay/index.js' /* webpackChunkName: "pages/my-pay/index" */))
const _4b1cf232 = () => interopDefault(import('../../../src/pages/my-pay/index/pay-settings.js' /* webpackChunkName: "pages/my-pay/index/pay-settings" */))
const _4330c9c6 = () => interopDefault(import('../../../src/pages/my-pay/index/pay-statements.js' /* webpackChunkName: "pages/my-pay/index/pay-statements" */))
const _5c93357c = () => interopDefault(import('../../../src/pages/my-pay/index/payments.js' /* webpackChunkName: "pages/my-pay/index/payments" */))
const _656f3092 = () => interopDefault(import('../../../src/pages/my-pay/index/paystubs.js' /* webpackChunkName: "pages/my-pay/index/paystubs" */))
const _487d13c2 = () => interopDefault(import('../../../src/pages/my-pay/index/setup.js' /* webpackChunkName: "pages/my-pay/index/setup" */))
const _bec34eee = () => interopDefault(import('../../../src/pages/my-pay/index/tax-documents.js' /* webpackChunkName: "pages/my-pay/index/tax-documents" */))
const _3f88ad89 = () => interopDefault(import('../../../src/pages/my-team/index.ts' /* webpackChunkName: "pages/my-team/index" */))
const _9287c9ce = () => interopDefault(import('../../../src/pages/my-time/index.ts' /* webpackChunkName: "pages/my-time/index" */))
const _1c09ad94 = () => interopDefault(import('../../../src/pages/my-time/index/index.ts' /* webpackChunkName: "pages/my-time/index/index" */))
const _061305ac = () => interopDefault(import('../../../src/pages/my-training/index.ts' /* webpackChunkName: "pages/my-training/index" */))
const _89a2ccee = () => interopDefault(import('../../../src/pages/my-training/index/index.ts' /* webpackChunkName: "pages/my-training/index/index" */))
const _24ef58bf = () => interopDefault(import('../../../src/pages/my-training/index/catalog/index.ts' /* webpackChunkName: "pages/my-training/index/catalog/index" */))
const _7b451257 = () => interopDefault(import('../../../src/pages/my-training/index/catalog/_course.ts' /* webpackChunkName: "pages/my-training/index/catalog/_course" */))
const _736ef33e = () => interopDefault(import('../../../src/pages/my-training/index/_id/index.ts' /* webpackChunkName: "pages/my-training/index/_id/index" */))
const _05393a37 = () => interopDefault(import('../../../src/pages/nuc-frame.vue' /* webpackChunkName: "pages/nuc-frame" */))
const _72f961ea = () => interopDefault(import('../../../src/pages/nuc-sub-frame.vue' /* webpackChunkName: "pages/nuc-sub-frame" */))
const _8f93633e = () => interopDefault(import('../../../src/pages/partner-marketplace.vue' /* webpackChunkName: "pages/partner-marketplace" */))
const _49215b04 = () => interopDefault(import('../../../src/pages/partner-offers.js' /* webpackChunkName: "pages/partner-offers" */))
const _4dc70308 = () => interopDefault(import('../../../src/pages/payroll-setup/index.js' /* webpackChunkName: "pages/payroll-setup/index" */))
const _e8f746ae = () => interopDefault(import('../../../src/pages/payroll-setup/index/bank-tax.js' /* webpackChunkName: "pages/payroll-setup/index/bank-tax" */))
const _62c278c5 = () => interopDefault(import('../../../src/pages/payroll-setup/index/company-info.js' /* webpackChunkName: "pages/payroll-setup/index/company-info" */))
const _3dfa0338 = () => interopDefault(import('../../../src/pages/payroll-setup/index/confirmation.ts' /* webpackChunkName: "pages/payroll-setup/index/confirmation" */))
const _0818d0d7 = () => interopDefault(import('../../../src/pages/payroll-setup/index/get-started.ts' /* webpackChunkName: "pages/payroll-setup/index/get-started" */))
const _a4acdc66 = () => interopDefault(import('../../../src/pages/payroll-setup/index/locations.js' /* webpackChunkName: "pages/payroll-setup/index/locations" */))
const _54a5c504 = () => interopDefault(import('../../../src/pages/payroll-setup/index/pay-schedule/index.js' /* webpackChunkName: "pages/payroll-setup/index/pay-schedule/index" */))
const _083d487f = () => interopDefault(import('../../../src/pages/payroll-setup/index/pay-schedule/index/create.js' /* webpackChunkName: "pages/payroll-setup/index/pay-schedule/index/create" */))
const _a9373eaa = () => interopDefault(import('../../../src/pages/payroll-setup/index/pay-schedule/index/preview.js' /* webpackChunkName: "pages/payroll-setup/index/pay-schedule/index/preview" */))
const _714c34a7 = () => interopDefault(import('../../../src/pages/payroll-setup/index/signatory-confirmation.js' /* webpackChunkName: "pages/payroll-setup/index/signatory-confirmation" */))
const _06653b76 = () => interopDefault(import('../../../src/pages/personal-insurance/index.vue' /* webpackChunkName: "pages/personal-insurance/index" */))
const _7353db4a = () => interopDefault(import('../../../src/pages/policy/index.ts' /* webpackChunkName: "pages/policy/index" */))
const _06e4ce44 = () => interopDefault(import('../../../src/pages/profile.vue' /* webpackChunkName: "pages/profile" */))
const _9ef2dc72 = () => interopDefault(import('../../../src/pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _c0a0740c = () => interopDefault(import('../../../src/pages/profile/folders.vue' /* webpackChunkName: "pages/profile/folders" */))
const _183c72c3 = () => interopDefault(import('../../../src/pages/report-cards/index.ts' /* webpackChunkName: "pages/report-cards/index" */))
const _dafccd40 = () => interopDefault(import('../../../src/pages/report-cards/index/index.ts' /* webpackChunkName: "pages/report-cards/index/index" */))
const _5556e749 = () => interopDefault(import('../../../src/pages/requests/index.ts' /* webpackChunkName: "pages/requests/index" */))
const _17781166 = () => interopDefault(import('../../../src/pages/requests/index/index.ts' /* webpackChunkName: "pages/requests/index/index" */))
const _6a79d8bf = () => interopDefault(import('../../../src/pages/requests/index/_type.ts' /* webpackChunkName: "pages/requests/index/_type" */))
const _cf54a0e4 = () => interopDefault(import('../../../src/pages/reset-password.vue' /* webpackChunkName: "pages/reset-password" */))
const _86eb773c = () => interopDefault(import('../../../src/pages/sandbox.vue' /* webpackChunkName: "pages/sandbox" */))
const _cd52d7b0 = () => interopDefault(import('../../../src/pages/task/index.ts' /* webpackChunkName: "pages/task/index" */))
const _3b6b1580 = () => interopDefault(import('../../../src/pages/task/index/pay-frequency.ts' /* webpackChunkName: "pages/task/index/pay-frequency" */))
const _1adbc086 = () => interopDefault(import('../../../src/pages/time-and-attendance/index.vue' /* webpackChunkName: "pages/time-and-attendance/index" */))
const _5bd416f3 = () => interopDefault(import('../../../src/pages/training/index.ts' /* webpackChunkName: "pages/training/index" */))
const _1c0d4ce0 = () => interopDefault(import('../../../src/pages/training/index/index.ts' /* webpackChunkName: "pages/training/index/index" */))
const _30672e62 = () => interopDefault(import('../../../src/pages/training/index/index/company.ts' /* webpackChunkName: "pages/training/index/index/company" */))
const _ac075db8 = () => interopDefault(import('../../../src/pages/training/index/index/my-courses.ts' /* webpackChunkName: "pages/training/index/index/my-courses" */))
const _0038ec82 = () => interopDefault(import('../../../src/pages/training/index/index/overview.ts' /* webpackChunkName: "pages/training/index/index/overview" */))
const _3f775257 = () => interopDefault(import('../../../src/pages/training/index/index/requests.ts' /* webpackChunkName: "pages/training/index/index/requests" */))
const _52d921c6 = () => interopDefault(import('../../../src/pages/training/index/catalog/index.ts' /* webpackChunkName: "pages/training/index/catalog/index" */))
const _543e94c4 = () => interopDefault(import('../../../src/pages/training/index/catalog/_course.ts' /* webpackChunkName: "pages/training/index/catalog/_course" */))
const _000ba452 = () => interopDefault(import('../../../src/pages/training/index/course/_id.ts' /* webpackChunkName: "pages/training/index/course/_id" */))
const _71875076 = () => interopDefault(import('../../../src/pages/training/index/_id/index.ts' /* webpackChunkName: "pages/training/index/_id/index" */))
const _57d85aec = () => interopDefault(import('../../../src/pages/voices/index.ts' /* webpackChunkName: "pages/voices/index" */))
const _df22026e = () => interopDefault(import('../../../src/pages/voices/index/index.ts' /* webpackChunkName: "pages/voices/index/index" */))
const _5198928a = () => interopDefault(import('../../../src/pages/voices/index/new.ts' /* webpackChunkName: "pages/voices/index/new" */))
const _07d74906 = () => interopDefault(import('../../../src/pages/welcome.vue' /* webpackChunkName: "pages/welcome" */))
const _6403271c = () => interopDefault(import('../../../src/pages/welcome-handout/index.vue' /* webpackChunkName: "pages/welcome-handout/index" */))
const _3a5a5574 = () => interopDefault(import('../../../src/pages/workplace-violence-prevention.vue' /* webpackChunkName: "pages/workplace-violence-prevention" */))
const _908e990c = () => interopDefault(import('../../../src/pages/dashboard/complex-payroll/index.ts' /* webpackChunkName: "pages/dashboard/complex-payroll/index" */))
const _23075c34 = () => interopDefault(import('../../../src/pages/dashboard/consider-guided-payroll.vue' /* webpackChunkName: "pages/dashboard/consider-guided-payroll" */))
const _3171e61c = () => interopDefault(import('../../../src/pages/dashboard/finish-setup-account.ts' /* webpackChunkName: "pages/dashboard/finish-setup-account" */))
const _7e53d787 = () => interopDefault(import('../../../src/pages/dashboard/lite.ts' /* webpackChunkName: "pages/dashboard/lite" */))
const _1cf98241 = () => interopDefault(import('../../../src/pages/dashboard/migrate-payroll-data.ts' /* webpackChunkName: "pages/dashboard/migrate-payroll-data" */))
const _470c0eaf = () => interopDefault(import('../../../src/pages/dashboard/pause.ts' /* webpackChunkName: "pages/dashboard/pause" */))
const _634c928a = () => interopDefault(import('../../../src/pages/dashboard/schedule-call-hrm.vue' /* webpackChunkName: "pages/dashboard/schedule-call-hrm" */))
const _66688a8c = () => interopDefault(import('../../../src/pages/dashboard/schedule-call-payroll.vue' /* webpackChunkName: "pages/dashboard/schedule-call-payroll" */))
const _4b2d1303 = () => interopDefault(import('../../../src/pages/dashboard/schedule-call-training.vue' /* webpackChunkName: "pages/dashboard/schedule-call-training" */))
const _1950e880 = () => interopDefault(import('../../../src/pages/dashboard/setup-company-policies.vue' /* webpackChunkName: "pages/dashboard/setup-company-policies" */))
const _498c7835 = () => interopDefault(import('../../../src/pages/dashboard/setup-employee-voices.ts' /* webpackChunkName: "pages/dashboard/setup-employee-voices" */))
const _3404b5e8 = () => interopDefault(import('../../../src/pages/dashboard/setup-report-card.ts' /* webpackChunkName: "pages/dashboard/setup-report-card" */))
const _2b630bec = () => interopDefault(import('../../../src/pages/dashboard/storage.ts' /* webpackChunkName: "pages/dashboard/storage" */))
const _10310fc7 = () => interopDefault(import('../../../src/pages/dashboard/take-hr-audit.ts' /* webpackChunkName: "pages/dashboard/take-hr-audit" */))
const _ebf894ee = () => interopDefault(import('../../../src/pages/dashboard/upload-documents.ts' /* webpackChunkName: "pages/dashboard/upload-documents" */))
const _b55b7434 = () => interopDefault(import('../../../src/pages/employee-welcome/setup.vue' /* webpackChunkName: "pages/employee-welcome/setup" */))
const _781f34a7 = () => interopDefault(import('../../../src/pages/employee-welcome/setup/meet-hr.vue' /* webpackChunkName: "pages/employee-welcome/setup/meet-hr" */))
const _1d893cdf = () => interopDefault(import('../../../src/pages/employee-welcome/setup/set-password.vue' /* webpackChunkName: "pages/employee-welcome/setup/set-password" */))
const _b2e1f43e = () => interopDefault(import('../../../src/pages/employee-welcome/setup/sign-doc.vue' /* webpackChunkName: "pages/employee-welcome/setup/sign-doc" */))
const _22d487a3 = () => interopDefault(import('../../../src/pages/end-of-employment/wizard/index.ts' /* webpackChunkName: "pages/end-of-employment/wizard/index" */))
const _5733c4d6 = () => interopDefault(import('../../../src/pages/get-time-and-attendance/processing.ts' /* webpackChunkName: "pages/get-time-and-attendance/processing" */))
const _4e32db2c = () => interopDefault(import('../../../src/pages/hr-intelligence/hr-guidance/index.vue' /* webpackChunkName: "pages/hr-intelligence/hr-guidance/index" */))
const _05bfff9f = () => interopDefault(import('../../../src/pages/insurance/add-plan.vue' /* webpackChunkName: "pages/insurance/add-plan" */))
const _313b39d2 = () => interopDefault(import('../../../src/pages/insurance/transfer-plans.vue' /* webpackChunkName: "pages/insurance/transfer-plans" */))
const _064156d8 = () => interopDefault(import('../../../src/pages/onboarding/employer/index.ts' /* webpackChunkName: "pages/onboarding/employer/index" */))
const _09d0666a = () => interopDefault(import('../../../src/pages/onboarding/employer/index/about-company.ts' /* webpackChunkName: "pages/onboarding/employer/index/about-company" */))
const _1dcea7e2 = () => interopDefault(import('../../../src/pages/onboarding/employer/index/about-employees.ts' /* webpackChunkName: "pages/onboarding/employer/index/about-employees" */))
const _8cd6def0 = () => interopDefault(import('../../../src/pages/onboarding/employer/index/about-you.ts' /* webpackChunkName: "pages/onboarding/employer/index/about-you" */))
const _26385dbb = () => interopDefault(import('../../../src/pages/onboarding/employer/index/add-documents.ts' /* webpackChunkName: "pages/onboarding/employer/index/add-documents" */))
const _3e6aea40 = () => interopDefault(import('../../../src/pages/onboarding/employer/index/add-owner.ts' /* webpackChunkName: "pages/onboarding/employer/index/add-owner" */))
const _95823b84 = () => interopDefault(import('../../../src/pages/onboarding/employer/index/add-pin.ts' /* webpackChunkName: "pages/onboarding/employer/index/add-pin" */))
const _15115d20 = () => interopDefault(import('../../../src/pages/onboarding/employer/index/bionic-hr.ts' /* webpackChunkName: "pages/onboarding/employer/index/bionic-hr" */))
const _553c6e65 = () => interopDefault(import('../../../src/pages/onboarding/employer/index/business-location.ts' /* webpackChunkName: "pages/onboarding/employer/index/business-location" */))
const _1b09af72 = () => interopDefault(import('../../../src/pages/onboarding/employer/index/case-management.ts' /* webpackChunkName: "pages/onboarding/employer/index/case-management" */))
const _de304fa0 = () => interopDefault(import('../../../src/pages/onboarding/employer/index/cognitive-employee-support.ts' /* webpackChunkName: "pages/onboarding/employer/index/cognitive-employee-support" */))
const _3da9e1be = () => interopDefault(import('../../../src/pages/onboarding/employer/index/discussion-topics.ts' /* webpackChunkName: "pages/onboarding/employer/index/discussion-topics" */))
const _29e0c61f = () => interopDefault(import('../../../src/pages/onboarding/employer/index/education.ts' /* webpackChunkName: "pages/onboarding/employer/index/education" */))
const _6260ba96 = () => interopDefault(import('../../../src/pages/onboarding/employer/index/enable-bambee-company-rollout.ts' /* webpackChunkName: "pages/onboarding/employer/index/enable-bambee-company-rollout" */))
const _2d9d55f4 = () => interopDefault(import('../../../src/pages/onboarding/employer/index/enable-bionic-hr.ts' /* webpackChunkName: "pages/onboarding/employer/index/enable-bionic-hr" */))
const _2b8eb35a = () => interopDefault(import('../../../src/pages/onboarding/employer/index/enable-cognitive-employee-support.ts' /* webpackChunkName: "pages/onboarding/employer/index/enable-cognitive-employee-support" */))
const _4a0003f3 = () => interopDefault(import('../../../src/pages/onboarding/employer/index/enable-employee-issue-tracking.ts' /* webpackChunkName: "pages/onboarding/employer/index/enable-employee-issue-tracking" */))
const _37fd196e = () => interopDefault(import('../../../src/pages/onboarding/employer/index/enable-hands-on-hr.ts' /* webpackChunkName: "pages/onboarding/employer/index/enable-hands-on-hr" */))
const _edcb02b2 = () => interopDefault(import('../../../src/pages/onboarding/employer/index/enable-hr-action-plans.ts' /* webpackChunkName: "pages/onboarding/employer/index/enable-hr-action-plans" */))
const _45fc41d5 = () => interopDefault(import('../../../src/pages/onboarding/employer/index/enable-manager-coaching.ts' /* webpackChunkName: "pages/onboarding/employer/index/enable-manager-coaching" */))
const _675bd0d4 = () => interopDefault(import('../../../src/pages/onboarding/employer/index/enable-neural-compliance.ts' /* webpackChunkName: "pages/onboarding/employer/index/enable-neural-compliance" */))
const _1817600a = () => interopDefault(import('../../../src/pages/onboarding/employer/index/enable-neural-intelligence-and-compliance-tracking.ts' /* webpackChunkName: "pages/onboarding/employer/index/enable-neural-intelligence-and-compliance-tracking" */))
const _4cac303b = () => interopDefault(import('../../../src/pages/onboarding/employer/index/expert-hr-guidance.ts' /* webpackChunkName: "pages/onboarding/employer/index/expert-hr-guidance" */))
const _4ab5a358 = () => interopDefault(import('../../../src/pages/onboarding/employer/index/hands-on-hr.ts' /* webpackChunkName: "pages/onboarding/employer/index/hands-on-hr" */))
const _e753dc46 = () => interopDefault(import('../../../src/pages/onboarding/employer/index/let-bambee-handle-hr-for-you.ts' /* webpackChunkName: "pages/onboarding/employer/index/let-bambee-handle-hr-for-you" */))
const _203bc33e = () => interopDefault(import('../../../src/pages/onboarding/employer/index/neural-compliance.ts' /* webpackChunkName: "pages/onboarding/employer/index/neural-compliance" */))
const _1545603a = () => interopDefault(import('../../../src/pages/onboarding/employer/index/overview.ts' /* webpackChunkName: "pages/onboarding/employer/index/overview" */))
const _4a138fce = () => interopDefault(import('../../../src/pages/onboarding/employer/index/owner-check.ts' /* webpackChunkName: "pages/onboarding/employer/index/owner-check" */))
const _76533d43 = () => interopDefault(import('../../../src/pages/onboarding/employer/index/permissions.ts' /* webpackChunkName: "pages/onboarding/employer/index/permissions" */))
const _98a27d1a = () => interopDefault(import('../../../src/pages/onboarding/employer/index/schedule-call.ts' /* webpackChunkName: "pages/onboarding/employer/index/schedule-call" */))
const _18031aa3 = () => interopDefault(import('../../../src/pages/onboarding/employer/index/select-first-action.ts' /* webpackChunkName: "pages/onboarding/employer/index/select-first-action" */))
const _1232a196 = () => interopDefault(import('../../../src/pages/onboarding/employer/index/set-up-employees.ts' /* webpackChunkName: "pages/onboarding/employer/index/set-up-employees" */))
const _fb4e883e = () => interopDefault(import('../../../src/pages/onboarding/employer/index/summary.ts' /* webpackChunkName: "pages/onboarding/employer/index/summary" */))
const _19136f8b = () => interopDefault(import('../../../src/pages/onboarding/employer/index/transition-to-employee.ts' /* webpackChunkName: "pages/onboarding/employer/index/transition-to-employee" */))
const _421dcb0a = () => interopDefault(import('../../../src/pages/onboarding/employer/index/transition-to-files.ts' /* webpackChunkName: "pages/onboarding/employer/index/transition-to-files" */))
const _7909f578 = () => interopDefault(import('../../../src/pages/onboarding/employer/index/transition-to-setup.ts' /* webpackChunkName: "pages/onboarding/employer/index/transition-to-setup" */))
const _505b4478 = () => interopDefault(import('../../../src/pages/onboarding/employer/index/request-details/_request.ts' /* webpackChunkName: "pages/onboarding/employer/index/request-details/_request" */))
const _4b963334 = () => interopDefault(import('../../../src/pages/payroll-activation/get-started/index.ts' /* webpackChunkName: "pages/payroll-activation/get-started/index" */))
const _252b8111 = () => interopDefault(import('../../../src/pages/payroll-activation/get-started/index/index.ts' /* webpackChunkName: "pages/payroll-activation/get-started/index/index" */))
const _3b6899a7 = () => interopDefault(import('../../../src/pages/payroll-activation/get-started/index/add-fein.ts' /* webpackChunkName: "pages/payroll-activation/get-started/index/add-fein" */))
const _20a93de5 = () => interopDefault(import('../../../src/pages/payroll-activation/get-started/index/add-payroll-worker.ts' /* webpackChunkName: "pages/payroll-activation/get-started/index/add-payroll-worker" */))
const _16c653bc = () => interopDefault(import('../../../src/pages/payroll-activation/get-started/index/add-payroll-workers.ts' /* webpackChunkName: "pages/payroll-activation/get-started/index/add-payroll-workers" */))
const _4a27f16e = () => interopDefault(import('../../../src/pages/payroll-activation/get-started/index/add-training-workers.ts' /* webpackChunkName: "pages/payroll-activation/get-started/index/add-training-workers" */))
const _54d4fe0a = () => interopDefault(import('../../../src/pages/payroll-activation/get-started/index/authorization.ts' /* webpackChunkName: "pages/payroll-activation/get-started/index/authorization" */))
const _06bd76b2 = () => interopDefault(import('../../../src/pages/payroll-activation/get-started/index/bambee-plus-outro.ts' /* webpackChunkName: "pages/payroll-activation/get-started/index/bambee-plus-outro" */))
const _7a65287e = () => interopDefault(import('../../../src/pages/payroll-activation/get-started/index/business-location.ts' /* webpackChunkName: "pages/payroll-activation/get-started/index/business-location" */))
const _5260245c = () => interopDefault(import('../../../src/pages/payroll-activation/get-started/index/confirm-account-info.ts' /* webpackChunkName: "pages/payroll-activation/get-started/index/confirm-account-info" */))
const _2c5b0532 = () => interopDefault(import('../../../src/pages/payroll-activation/get-started/index/current-payroll.ts' /* webpackChunkName: "pages/payroll-activation/get-started/index/current-payroll" */))
const _faa26e84 = () => interopDefault(import('../../../src/pages/payroll-activation/get-started/index/forward.ts' /* webpackChunkName: "pages/payroll-activation/get-started/index/forward" */))
const _03c3937a = () => interopDefault(import('../../../src/pages/payroll-activation/get-started/index/how-to-time-attendance.ts' /* webpackChunkName: "pages/payroll-activation/get-started/index/how-to-time-attendance" */))
const _7578b38e = () => interopDefault(import('../../../src/pages/payroll-activation/get-started/index/how-to-use-training.ts' /* webpackChunkName: "pages/payroll-activation/get-started/index/how-to-use-training" */))
const _ce3acf7a = () => interopDefault(import('../../../src/pages/payroll-activation/get-started/index/legal-address.ts' /* webpackChunkName: "pages/payroll-activation/get-started/index/legal-address" */))
const _7d515371 = () => interopDefault(import('../../../src/pages/payroll-activation/get-started/index/mailing-address.ts' /* webpackChunkName: "pages/payroll-activation/get-started/index/mailing-address" */))
const _6c4b577a = () => interopDefault(import('../../../src/pages/payroll-activation/get-started/index/payroll-confirmation.ts' /* webpackChunkName: "pages/payroll-activation/get-started/index/payroll-confirmation" */))
const _027d4a40 = () => interopDefault(import('../../../src/pages/payroll-activation/get-started/index/payroll-outro.ts' /* webpackChunkName: "pages/payroll-activation/get-started/index/payroll-outro" */))
const _26c9a32e = () => interopDefault(import('../../../src/pages/payroll-activation/get-started/index/setup-payroll.ts' /* webpackChunkName: "pages/payroll-activation/get-started/index/setup-payroll" */))
const _400bd6b8 = () => interopDefault(import('../../../src/pages/payroll-activation/get-started/index/time-and-attendance.ts' /* webpackChunkName: "pages/payroll-activation/get-started/index/time-and-attendance" */))
const _11b1feb4 = () => interopDefault(import('../../../src/pages/payroll-activation/get-started/index/time-and-attendance-outro.ts' /* webpackChunkName: "pages/payroll-activation/get-started/index/time-and-attendance-outro" */))
const _743974c2 = () => interopDefault(import('../../../src/pages/payroll-activation/get-started/index/training-outro.ts' /* webpackChunkName: "pages/payroll-activation/get-started/index/training-outro" */))
const _7f07f9ce = () => interopDefault(import('../../../src/pages/payroll-activation/get-started/index/welcome-to-payroll.ts' /* webpackChunkName: "pages/payroll-activation/get-started/index/welcome-to-payroll" */))
const _1452ff02 = () => interopDefault(import('../../../src/pages/payroll-activation/get-started/index/welcome-to-training.ts' /* webpackChunkName: "pages/payroll-activation/get-started/index/welcome-to-training" */))
const _d12e19e8 = () => interopDefault(import('../../../src/pages/payroll-setup/connect-provider.js' /* webpackChunkName: "pages/payroll-setup/connect-provider" */))
const _0dd5325d = () => interopDefault(import('../../../src/pages/payroll-setup/provider-confirmation.js' /* webpackChunkName: "pages/payroll-setup/provider-confirmation" */))
const _095da19c = () => interopDefault(import('../../../src/pages/privacy/privacy.vue' /* webpackChunkName: "pages/privacy/privacy" */))
const _49c82c3b = () => interopDefault(import('../../../src/pages/settings/add-payment-method.vue' /* webpackChunkName: "pages/settings/add-payment-method" */))
const _0767de6a = () => interopDefault(import('../../../src/pages/settings/billing-history.vue' /* webpackChunkName: "pages/settings/billing-history" */))
const _7b49cff4 = () => interopDefault(import('../../../src/pages/settings/payment-methods.vue' /* webpackChunkName: "pages/settings/payment-methods" */))
const _2765cd44 = () => interopDefault(import('../../../src/pages/upgrade/benefits.vue' /* webpackChunkName: "pages/upgrade/benefits" */))
const _089d8566 = () => interopDefault(import('../../../src/pages/upgrade/payroll.vue' /* webpackChunkName: "pages/upgrade/payroll" */))
const _31e80ddc = () => interopDefault(import('../../../src/pages/upgrade/report-cards.vue' /* webpackChunkName: "pages/upgrade/report-cards" */))
const _6cc08a4c = () => interopDefault(import('../../../src/pages/upgrade/requests.vue' /* webpackChunkName: "pages/upgrade/requests" */))
const _483f1ac7 = () => interopDefault(import('../../../src/pages/upgrade/time-and-attendance.vue' /* webpackChunkName: "pages/upgrade/time-and-attendance" */))
const _8d45f4ee = () => interopDefault(import('../../../src/pages/upgrade/voices.vue' /* webpackChunkName: "pages/upgrade/voices" */))
const _26ece9e8 = () => interopDefault(import('../../../src/pages/onboarding/employer/index.ai.ts' /* webpackChunkName: "pages/onboarding/employer/index.ai" */))
const _2161a298 = () => interopDefault(import('../../../src/pages/document/job-description/_id.vue' /* webpackChunkName: "pages/document/job-description/_id" */))
const _7db84c60 = () => interopDefault(import('../../../src/pages/document/reaffirm/_id.vue' /* webpackChunkName: "pages/document/reaffirm/_id" */))
const _7840b9d7 = () => interopDefault(import('../../../src/pages/guidance/detail/_id.ts' /* webpackChunkName: "pages/guidance/detail/_id" */))
const _481d7d18 = () => interopDefault(import('../../../src/pages/guidance/detail/_id/index.ts' /* webpackChunkName: "pages/guidance/detail/_id/index" */))
const _7a97bcc4 = () => interopDefault(import('../../../src/pages/insurance/plans/_planId.vue' /* webpackChunkName: "pages/insurance/plans/_planId" */))
const _52bd90e0 = () => interopDefault(import('../../../src/pages/policy/details/_id.ts' /* webpackChunkName: "pages/policy/details/_id" */))
const _10451dac = () => interopDefault(import('../../../src/pages/qna/by-type/_type.vue' /* webpackChunkName: "pages/qna/by-type/_type" */))
const _33cffd7a = () => interopDefault(import('../../../src/pages/requests/detail/_id.ts' /* webpackChunkName: "pages/requests/detail/_id" */))
const _781847e0 = () => interopDefault(import('../../../src/pages/requests/detail/_id/index.ts' /* webpackChunkName: "pages/requests/detail/_id/index" */))
const _56427565 = () => interopDefault(import('../../../src/pages/requests/detail/_id/conversation.ts' /* webpackChunkName: "pages/requests/detail/_id/conversation" */))
const _459a181b = () => interopDefault(import('../../../src/pages/requests/detail/_id/files.ts' /* webpackChunkName: "pages/requests/detail/_id/files" */))
const _3787629e = () => interopDefault(import('../../../src/pages/create-request/_id.vue' /* webpackChunkName: "pages/create-request/_id" */))
const _43d485bb = () => interopDefault(import('../../../src/pages/document/_id.vue' /* webpackChunkName: "pages/document/_id" */))
const _a6e020c8 = () => interopDefault(import('../../../src/pages/file/_id.vue' /* webpackChunkName: "pages/file/_id" */))
const _2839766f = () => interopDefault(import('../../../src/pages/get-started/_slug.js' /* webpackChunkName: "pages/get-started/_slug" */))
const _047b641f = () => interopDefault(import('../../../src/pages/goal/_name/index.ts' /* webpackChunkName: "pages/goal/_name/index" */))
const _932caa30 = () => interopDefault(import('../../../src/pages/hr-intelligence/_id.vue' /* webpackChunkName: "pages/hr-intelligence/_id" */))
const _327abc8a = () => interopDefault(import('../../../src/pages/meetings/_id/index.vue' /* webpackChunkName: "pages/meetings/_id/index" */))
const _99770426 = () => interopDefault(import('../../../src/pages/pip/_document_id.vue' /* webpackChunkName: "pages/pip/_document_id" */))
const _afb7c2a0 = () => interopDefault(import('../../../src/pages/pip/_document_id/index.vue' /* webpackChunkName: "pages/pip/_document_id/index" */))
const _3b51e30d = () => interopDefault(import('../../../src/pages/policy-preview/_id.vue' /* webpackChunkName: "pages/policy-preview/_id" */))
const _475a14aa = () => interopDefault(import('../../../src/pages/qna/_id.vue' /* webpackChunkName: "pages/qna/_id" */))
const _52b70eac = () => interopDefault(import('../../../src/pages/report-cards/_id.vue' /* webpackChunkName: "pages/report-cards/_id" */))
const _77199f78 = () => interopDefault(import('../../../src/pages/report-cards/_id/index.ts' /* webpackChunkName: "pages/report-cards/_id/index" */))
const _a0bc0670 = () => interopDefault(import('../../../src/pages/report-cards/_id/details.ts' /* webpackChunkName: "pages/report-cards/_id/details" */))
const _2ba1bdae = () => interopDefault(import('../../../src/pages/settings/_page.ts' /* webpackChunkName: "pages/settings/_page" */))
const _364d60de = () => interopDefault(import('../../../src/pages/verbal-warning/_document_id.vue' /* webpackChunkName: "pages/verbal-warning/_document_id" */))
const _34962554 = () => interopDefault(import('../../../src/pages/verbal-warning/_document_id/index.vue' /* webpackChunkName: "pages/verbal-warning/_document_id/index" */))
const _a1b97204 = () => interopDefault(import('../../../src/pages/written-warning/_document_id.vue' /* webpackChunkName: "pages/written-warning/_document_id" */))
const _0d521701 = () => interopDefault(import('../../../src/pages/written-warning/_document_id/index.vue' /* webpackChunkName: "pages/written-warning/_document_id/index" */))
const _020d3c6a = () => interopDefault(import('../../../src/pages/insurance/_planId/sign-bor.vue' /* webpackChunkName: "pages/insurance/_planId/sign-bor" */))
const _64d4e723 = () => interopDefault(import('../../../src/pages/policy/_id/document-preview.vue' /* webpackChunkName: "pages/policy/_id/document-preview" */))
const _25b4ef6a = () => interopDefault(import('../../../src/pages/policy/_id/preview.vue' /* webpackChunkName: "pages/policy/_id/preview" */))
const _5c7375ad = () => interopDefault(import('../../../src/pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about-bambee",
    component: _2d6aa799,
    name: "about-bambee",
    children: [{
      path: "audits",
      component: _304b020c,
      name: "about-bambee-index-audits"
    }, {
      path: "document-retention",
      component: _407ac3f4,
      name: "about-bambee-index-document-retention"
    }, {
      path: "employee-feedback",
      component: _9e49f5f8,
      name: "about-bambee-index-employee-feedback"
    }, {
      path: "hr-manager",
      component: _15560148,
      name: "about-bambee-index-hr-manager"
    }, {
      path: "onboarding-termination",
      component: _e962bf40,
      name: "about-bambee-index-onboarding-termination"
    }, {
      path: "payment",
      component: _ac91c9ba,
      name: "about-bambee-index-payment"
    }, {
      path: "payment-confirm",
      component: _72de0ed4,
      name: "about-bambee-index-payment-confirm"
    }, {
      path: "payroll",
      component: _272b61c3,
      name: "about-bambee-index-payroll"
    }, {
      path: "policies",
      component: _6bb33162,
      name: "about-bambee-index-policies"
    }, {
      path: "training",
      component: _f8e114d0,
      name: "about-bambee-index-training"
    }, {
      path: "welcome",
      component: _73454334,
      name: "about-bambee-index-welcome"
    }]
  }, {
    path: "/activate-account",
    component: _460c8548,
    name: "activate-account"
  }, {
    path: "/activation",
    component: _2f78f74b,
    name: "activation"
  }, {
    path: "/activation-expired",
    component: _49459aba,
    name: "activation-expired"
  }, {
    path: "/add-worker",
    component: _5a7496e3,
    name: "add-worker"
  }, {
    path: "/benefits",
    component: _7e46815e,
    children: [{
      path: "",
      component: _17247924,
      name: "benefits-index"
    }, {
      path: "connect",
      component: _37f81396,
      name: "benefits-index-connect"
    }, {
      path: "manage",
      component: _a57f1096,
      name: "benefits-index-manage"
    }, {
      path: "shop",
      component: _0700a3c4,
      name: "benefits-index-shop"
    }]
  }, {
    path: "/ca-workplace-violence",
    component: _35bb8f1c,
    name: "ca-workplace-violence"
  }, {
    path: "/cabinet",
    component: _281c911a,
    name: "cabinet",
    children: [{
      path: "active",
      component: _49d9eed2,
      name: "cabinet-active"
    }, {
      path: "CabinetImage",
      component: _4fec144f,
      name: "cabinet-CabinetImage"
    }]
  }, {
    path: "/cancellation",
    component: _2d86db6a,
    children: [{
      path: "",
      component: _128ea8c7,
      name: "cancellation-index"
    }, {
      path: "confirmation",
      component: _922524a8,
      name: "cancellation-index-confirmation"
    }, {
      path: "extend-trial",
      component: _9d67d704,
      name: "cancellation-index-extend-trial"
    }, {
      path: "offer-accepted",
      component: _3be92bee,
      name: "cancellation-index-offer-accepted"
    }, {
      path: "reason",
      component: _4792283d,
      name: "cancellation-index-reason"
    }, {
      path: "reasons",
      component: _aa5d926c,
      name: "cancellation-index-reasons"
    }, {
      path: "save-account",
      component: _5974d704,
      name: "cancellation-index-save-account"
    }, {
      path: "trial-extended",
      component: _af72ee1e,
      name: "cancellation-index-trial-extended"
    }, {
      path: "offer/:id?",
      component: _76f0c7f2,
      name: "cancellation-index-offer-id"
    }]
  }, {
    path: "/company-setup",
    component: _d8f3754c,
    name: "company-setup"
  }, {
    path: "/conversations",
    component: _4d6e3cd2,
    name: "conversations"
  }, {
    path: "/customizing",
    component: _5e38ed8a,
    name: "customizing"
  }, {
    path: "/dashboard",
    component: _01d5ce53,
    children: [{
      path: "",
      component: _8427ee20,
      name: "dashboard-index"
    }]
  }, {
    path: "/employee",
    component: _285dd423,
    children: [{
      path: "",
      component: _687b8669,
      name: "employee"
    }, {
      path: "add",
      component: _534593b5,
      name: "employee-add"
    }, {
      path: "bulk-add",
      component: _21479182,
      name: "employee-bulk-add"
    }, {
      path: "create-job-description/:id?",
      component: _68b06eba,
      name: "employee-create-job-description-id"
    }, {
      path: "edit/:id?",
      component: _19b76dd4,
      name: "employee-edit-id"
    }, {
      path: ":id",
      component: _1bfd4f64,
      children: [{
        path: "",
        component: _0391ec51,
        name: "employee-id"
      }, {
        path: "folders",
        component: _5d4ea604,
        name: "employee-id-folders"
      }, {
        path: "job-description",
        component: _0347ec24,
        name: "employee-id-job-description"
      }, {
        path: "notes",
        component: _04f5f943,
        name: "employee-id-notes"
      }, {
        path: "profile",
        component: _031ad7dd,
        name: "employee-id-profile"
      }, {
        path: "settings",
        component: _fd678418,
        name: "employee-id-settings"
      }, {
        path: "pip/:pip_id?",
        component: _45b997a9,
        children: [{
          path: "",
          component: _23b5fb6c,
          name: "employee-id-pip-pip_id"
        }, {
          path: "documents",
          component: _716c7152,
          name: "employee-id-pip-pip_id-documents"
        }, {
          path: "duration",
          component: _324f85ea,
          name: "employee-id-pip-pip_id-duration"
        }, {
          path: "goals",
          component: _5ff1e14c,
          name: "employee-id-pip-pip_id-goals"
        }, {
          path: "past-examples",
          component: _77e1a73e,
          name: "employee-id-pip-pip_id-past-examples"
        }, {
          path: "preview",
          component: _9fe1da3c,
          name: "employee-id-pip-pip_id-preview"
        }]
      }, {
        path: "verbal-warning/:verbal_id?",
        component: _2fe18b66,
        children: [{
          path: "",
          component: _2cd56d69,
          name: "employee-id-verbal-warning-verbal_id"
        }, {
          path: "consequences",
          component: _0f192449,
          name: "employee-id-verbal-warning-verbal_id-consequences"
        }, {
          path: "preview",
          component: _21cc0cc2,
          name: "employee-id-verbal-warning-verbal_id-preview"
        }]
      }, {
        path: "written-warning/:written_id?",
        component: _9cc9c810,
        children: [{
          path: "",
          component: _6c70c87b,
          name: "employee-id-written-warning-written_id"
        }, {
          path: "consequences",
          component: _73e690f7,
          name: "employee-id-written-warning-written_id-consequences"
        }, {
          path: "documents",
          component: _16cc1ee1,
          name: "employee-id-written-warning-written_id-documents"
        }, {
          path: "goals",
          component: _18c1dc69,
          name: "employee-id-written-warning-written_id-goals"
        }, {
          path: "preview",
          component: _956a4f9e,
          name: "employee-id-written-warning-written_id-preview"
        }]
      }]
    }]
  }, {
    path: "/employee-review",
    component: _7302c5f2,
    children: [{
      path: "",
      component: _2ae8e216,
      name: "employee-review"
    }, {
      path: "print",
      component: _d403045a,
      name: "employee-review-print"
    }, {
      path: "sign",
      component: _2afd2eed,
      name: "employee-review-sign"
    }, {
      path: "print/:id",
      component: _1eb04e0a,
      name: "employee-review-print-id"
    }, {
      path: "sign/:id",
      component: _27f40895,
      name: "employee-review-sign-id"
    }, {
      path: ":id",
      component: _cbaa6ac6,
      name: "employee-review-id"
    }]
  }, {
    path: "/employee-welcome",
    component: _185001bb,
    name: "employee-welcome"
  }, {
    path: "/errors",
    component: _6aa489a0,
    name: "errors"
  }, {
    path: "/forgot-password",
    component: _6a5694c0,
    name: "forgot-password"
  }, {
    path: "/get-bambee",
    component: _0157dfc0,
    name: "get-bambee"
  }, {
    path: "/get-benefits",
    component: _1a9a4b1a,
    name: "get-benefits"
  }, {
    path: "/get-payroll",
    component: _5c41f3e8,
    name: "get-payroll"
  }, {
    path: "/get-time-and-attendance",
    component: _5ae901ff,
    name: "get-time-and-attendance"
  }, {
    path: "/get-training",
    component: _94dcbcf4,
    children: [{
      path: "",
      component: _5631ad3a,
      name: "get-training-index"
    }, {
      path: "confirmation",
      component: _602ecb38,
      name: "get-training-index-confirmation"
    }]
  }, {
    path: "/goal",
    component: _649b2a5a,
    name: "goal"
  }, {
    path: "/guidance",
    component: _08da2235,
    children: [{
      path: "",
      component: _6b33295c,
      name: "guidance-index"
    }]
  }, {
    path: "/hr-actions",
    component: _754d4ab2,
    name: "hr-actions"
  }, {
    path: "/hr-intelligence",
    component: _1ad8ef00,
    name: "hr-intelligence"
  }, {
    path: "/hr-practice",
    component: _71817a08,
    name: "hr-practice"
  }, {
    path: "/insurance",
    component: _2ec1a0f8,
    name: "insurance"
  }, {
    path: "/job-description",
    component: _c061978a,
    name: "job-description"
  }, {
    path: "/login",
    component: _261b18c4,
    children: [{
      path: "",
      component: _0f7afc47,
      name: "login"
    }, {
      path: "forgot-pass",
      component: _fd9b44a0,
      name: "login-forgot-pass"
    }]
  }, {
    path: "/managed-services",
    component: _eaedd37e,
    children: [{
      path: "",
      component: _864db344,
      name: "managed-services-index"
    }, {
      path: "explore",
      component: _29e42c3d,
      name: "managed-services-index-explore"
    }, {
      path: ":service",
      component: _431809d4,
      name: "managed-services-index-service"
    }]
  }, {
    path: "/meetings",
    component: _a454d016,
    name: "meetings"
  }, {
    path: "/my-benefits",
    component: _6b1bae0a,
    children: [{
      path: "",
      component: _84b9f932,
      name: "my-benefits-index"
    }]
  }, {
    path: "/my-pay",
    component: _357d8e20,
    name: "my-pay",
    children: [{
      path: "pay-settings",
      component: _4b1cf232,
      name: "my-pay-index-pay-settings"
    }, {
      path: "pay-statements",
      component: _4330c9c6,
      name: "my-pay-index-pay-statements"
    }, {
      path: "payments",
      component: _5c93357c,
      name: "my-pay-index-payments"
    }, {
      path: "paystubs",
      component: _656f3092,
      name: "my-pay-index-paystubs"
    }, {
      path: "setup",
      component: _487d13c2,
      name: "my-pay-index-setup"
    }, {
      path: "tax-documents",
      component: _bec34eee,
      name: "my-pay-index-tax-documents"
    }]
  }, {
    path: "/my-team",
    component: _3f88ad89,
    name: "my-team"
  }, {
    path: "/my-time",
    component: _9287c9ce,
    children: [{
      path: "",
      component: _1c09ad94,
      name: "my-time-index"
    }]
  }, {
    path: "/my-training",
    component: _061305ac,
    children: [{
      path: "",
      component: _89a2ccee,
      name: "my-training-index"
    }, {
      path: "catalog",
      component: _24ef58bf,
      name: "my-training-index-catalog"
    }, {
      path: "catalog/:course?",
      component: _7b451257,
      name: "my-training-index-catalog-course"
    }, {
      path: ":id",
      component: _736ef33e,
      name: "my-training-index-id"
    }]
  }, {
    path: "/nuc-frame",
    component: _05393a37,
    name: "nuc-frame"
  }, {
    path: "/nuc-sub-frame",
    component: _72f961ea,
    name: "nuc-sub-frame"
  }, {
    path: "/partner-marketplace",
    component: _8f93633e,
    name: "partner-marketplace"
  }, {
    path: "/partner-offers",
    component: _49215b04,
    name: "partner-offers"
  }, {
    path: "/payroll-setup",
    component: _4dc70308,
    name: "payroll-setup",
    children: [{
      path: "bank-tax",
      component: _e8f746ae,
      name: "payroll-setup-index-bank-tax"
    }, {
      path: "company-info",
      component: _62c278c5,
      name: "payroll-setup-index-company-info"
    }, {
      path: "confirmation",
      component: _3dfa0338,
      name: "payroll-setup-index-confirmation"
    }, {
      path: "get-started",
      component: _0818d0d7,
      name: "payroll-setup-index-get-started"
    }, {
      path: "locations",
      component: _a4acdc66,
      name: "payroll-setup-index-locations"
    }, {
      path: "pay-schedule",
      component: _54a5c504,
      name: "payroll-setup-index-pay-schedule",
      children: [{
        path: "create",
        component: _083d487f,
        name: "payroll-setup-index-pay-schedule-index-create"
      }, {
        path: "preview",
        component: _a9373eaa,
        name: "payroll-setup-index-pay-schedule-index-preview"
      }]
    }, {
      path: "signatory-confirmation",
      component: _714c34a7,
      name: "payroll-setup-index-signatory-confirmation"
    }]
  }, {
    path: "/personal-insurance",
    component: _06653b76,
    name: "personal-insurance"
  }, {
    path: "/policy",
    component: _7353db4a,
    name: "policy"
  }, {
    path: "/profile",
    component: _06e4ce44,
    children: [{
      path: "",
      component: _9ef2dc72,
      name: "profile"
    }, {
      path: "folders",
      component: _c0a0740c,
      name: "profile-folders"
    }]
  }, {
    path: "/report-cards",
    component: _183c72c3,
    children: [{
      path: "",
      component: _dafccd40,
      name: "report-cards-index"
    }]
  }, {
    path: "/requests",
    component: _5556e749,
    children: [{
      path: "",
      component: _17781166,
      name: "requests-index"
    }, {
      path: ":type",
      component: _6a79d8bf,
      name: "requests-index-type"
    }]
  }, {
    path: "/reset-password",
    component: _cf54a0e4,
    name: "reset-password"
  }, {
    path: "/sandbox",
    component: _86eb773c,
    name: "sandbox"
  }, {
    path: "/task",
    component: _cd52d7b0,
    name: "task",
    children: [{
      path: "pay-frequency",
      component: _3b6b1580,
      name: "task-index-pay-frequency"
    }]
  }, {
    path: "/time-and-attendance",
    component: _1adbc086,
    name: "time-and-attendance"
  }, {
    path: "/training",
    component: _5bd416f3,
    children: [{
      path: "",
      component: _1c0d4ce0,
      name: "training-index",
      children: [{
        path: "company",
        component: _30672e62,
        name: "training-index-index-company"
      }, {
        path: "my-courses",
        component: _ac075db8,
        name: "training-index-index-my-courses"
      }, {
        path: "overview",
        component: _0038ec82,
        name: "training-index-index-overview"
      }, {
        path: "requests",
        component: _3f775257,
        name: "training-index-index-requests"
      }]
    }, {
      path: "catalog",
      component: _52d921c6,
      name: "training-index-catalog"
    }, {
      path: "catalog/:course?",
      component: _543e94c4,
      name: "training-index-catalog-course"
    }, {
      path: "course/:id?",
      component: _000ba452,
      name: "training-index-course-id"
    }, {
      path: ":id",
      component: _71875076,
      name: "training-index-id"
    }]
  }, {
    path: "/voices",
    component: _57d85aec,
    children: [{
      path: "",
      component: _df22026e,
      name: "voices-index"
    }, {
      path: "new",
      component: _5198928a,
      name: "voices-index-new"
    }]
  }, {
    path: "/welcome",
    component: _07d74906,
    name: "welcome"
  }, {
    path: "/welcome-handout",
    component: _6403271c,
    name: "welcome-handout"
  }, {
    path: "/workplace-violence-prevention",
    component: _3a5a5574,
    name: "workplace-violence-prevention"
  }, {
    path: "/dashboard/complex-payroll",
    component: _908e990c,
    name: "dashboard-complex-payroll"
  }, {
    path: "/dashboard/consider-guided-payroll",
    component: _23075c34,
    name: "dashboard-consider-guided-payroll"
  }, {
    path: "/dashboard/finish-setup-account",
    component: _3171e61c,
    name: "dashboard-finish-setup-account"
  }, {
    path: "/dashboard/lite",
    component: _7e53d787,
    name: "dashboard-lite"
  }, {
    path: "/dashboard/migrate-payroll-data",
    component: _1cf98241,
    name: "dashboard-migrate-payroll-data"
  }, {
    path: "/dashboard/pause",
    component: _470c0eaf,
    name: "dashboard-pause"
  }, {
    path: "/dashboard/schedule-call-hrm",
    component: _634c928a,
    name: "dashboard-schedule-call-hrm"
  }, {
    path: "/dashboard/schedule-call-payroll",
    component: _66688a8c,
    name: "dashboard-schedule-call-payroll"
  }, {
    path: "/dashboard/schedule-call-training",
    component: _4b2d1303,
    name: "dashboard-schedule-call-training"
  }, {
    path: "/dashboard/setup-company-policies",
    component: _1950e880,
    name: "dashboard-setup-company-policies"
  }, {
    path: "/dashboard/setup-employee-voices",
    component: _498c7835,
    name: "dashboard-setup-employee-voices"
  }, {
    path: "/dashboard/setup-report-card",
    component: _3404b5e8,
    name: "dashboard-setup-report-card"
  }, {
    path: "/dashboard/storage",
    component: _2b630bec,
    name: "dashboard-storage"
  }, {
    path: "/dashboard/take-hr-audit",
    component: _10310fc7,
    name: "dashboard-take-hr-audit"
  }, {
    path: "/dashboard/upload-documents",
    component: _ebf894ee,
    name: "dashboard-upload-documents"
  }, {
    path: "/employee-welcome/setup",
    component: _b55b7434,
    name: "employee-welcome-setup",
    children: [{
      path: "meet-hr",
      component: _781f34a7,
      name: "employee-welcome-setup-meet-hr"
    }, {
      path: "set-password",
      component: _1d893cdf,
      name: "employee-welcome-setup-set-password"
    }, {
      path: "sign-doc",
      component: _b2e1f43e,
      name: "employee-welcome-setup-sign-doc"
    }]
  }, {
    path: "/end-of-employment/wizard",
    component: _22d487a3,
    name: "end-of-employment-wizard"
  }, {
    path: "/get-time-and-attendance/processing",
    component: _5733c4d6,
    name: "get-time-and-attendance-processing"
  }, {
    path: "/hr-intelligence/hr-guidance",
    component: _4e32db2c,
    name: "hr-intelligence-hr-guidance"
  }, {
    path: "/insurance/add-plan",
    component: _05bfff9f,
    name: "insurance-add-plan"
  }, {
    path: "/insurance/transfer-plans",
    component: _313b39d2,
    name: "insurance-transfer-plans"
  }, {
    path: "/onboarding/employer",
    component: _064156d8,
    name: "onboarding-employer",
    children: [{
      path: "about-company",
      component: _09d0666a,
      name: "onboarding-employer-index-about-company"
    }, {
      path: "about-employees",
      component: _1dcea7e2,
      name: "onboarding-employer-index-about-employees"
    }, {
      path: "about-you",
      component: _8cd6def0,
      name: "onboarding-employer-index-about-you"
    }, {
      path: "add-documents",
      component: _26385dbb,
      name: "onboarding-employer-index-add-documents"
    }, {
      path: "add-owner",
      component: _3e6aea40,
      name: "onboarding-employer-index-add-owner"
    }, {
      path: "add-pin",
      component: _95823b84,
      name: "onboarding-employer-index-add-pin"
    }, {
      path: "bionic-hr",
      component: _15115d20,
      name: "onboarding-employer-index-bionic-hr"
    }, {
      path: "business-location",
      component: _553c6e65,
      name: "onboarding-employer-index-business-location"
    }, {
      path: "case-management",
      component: _1b09af72,
      name: "onboarding-employer-index-case-management"
    }, {
      path: "cognitive-employee-support",
      component: _de304fa0,
      name: "onboarding-employer-index-cognitive-employee-support"
    }, {
      path: "discussion-topics",
      component: _3da9e1be,
      name: "onboarding-employer-index-discussion-topics"
    }, {
      path: "education",
      component: _29e0c61f,
      name: "onboarding-employer-index-education"
    }, {
      path: "enable-bambee-company-rollout",
      component: _6260ba96,
      name: "onboarding-employer-index-enable-bambee-company-rollout"
    }, {
      path: "enable-bionic-hr",
      component: _2d9d55f4,
      name: "onboarding-employer-index-enable-bionic-hr"
    }, {
      path: "enable-cognitive-employee-support",
      component: _2b8eb35a,
      name: "onboarding-employer-index-enable-cognitive-employee-support"
    }, {
      path: "enable-employee-issue-tracking",
      component: _4a0003f3,
      name: "onboarding-employer-index-enable-employee-issue-tracking"
    }, {
      path: "enable-hands-on-hr",
      component: _37fd196e,
      name: "onboarding-employer-index-enable-hands-on-hr"
    }, {
      path: "enable-hr-action-plans",
      component: _edcb02b2,
      name: "onboarding-employer-index-enable-hr-action-plans"
    }, {
      path: "enable-manager-coaching",
      component: _45fc41d5,
      name: "onboarding-employer-index-enable-manager-coaching"
    }, {
      path: "enable-neural-compliance",
      component: _675bd0d4,
      name: "onboarding-employer-index-enable-neural-compliance"
    }, {
      path: "enable-neural-intelligence-and-compliance-tracking",
      component: _1817600a,
      name: "onboarding-employer-index-enable-neural-intelligence-and-compliance-tracking"
    }, {
      path: "expert-hr-guidance",
      component: _4cac303b,
      name: "onboarding-employer-index-expert-hr-guidance"
    }, {
      path: "hands-on-hr",
      component: _4ab5a358,
      name: "onboarding-employer-index-hands-on-hr"
    }, {
      path: "let-bambee-handle-hr-for-you",
      component: _e753dc46,
      name: "onboarding-employer-index-let-bambee-handle-hr-for-you"
    }, {
      path: "neural-compliance",
      component: _203bc33e,
      name: "onboarding-employer-index-neural-compliance"
    }, {
      path: "overview",
      component: _1545603a,
      name: "onboarding-employer-index-overview"
    }, {
      path: "owner-check",
      component: _4a138fce,
      name: "onboarding-employer-index-owner-check"
    }, {
      path: "permissions",
      component: _76533d43,
      name: "onboarding-employer-index-permissions"
    }, {
      path: "schedule-call",
      component: _98a27d1a,
      name: "onboarding-employer-index-schedule-call"
    }, {
      path: "select-first-action",
      component: _18031aa3,
      name: "onboarding-employer-index-select-first-action"
    }, {
      path: "set-up-employees",
      component: _1232a196,
      name: "onboarding-employer-index-set-up-employees"
    }, {
      path: "summary",
      component: _fb4e883e,
      name: "onboarding-employer-index-summary"
    }, {
      path: "transition-to-employee",
      component: _19136f8b,
      name: "onboarding-employer-index-transition-to-employee"
    }, {
      path: "transition-to-files",
      component: _421dcb0a,
      name: "onboarding-employer-index-transition-to-files"
    }, {
      path: "transition-to-setup",
      component: _7909f578,
      name: "onboarding-employer-index-transition-to-setup"
    }, {
      path: "request-details/:request?",
      component: _505b4478,
      name: "onboarding-employer-index-request-details-request"
    }]
  }, {
    path: "/payroll-activation/get-started",
    component: _4b963334,
    children: [{
      path: "",
      component: _252b8111,
      name: "payroll-activation-get-started-index"
    }, {
      path: "add-fein",
      component: _3b6899a7,
      name: "payroll-activation-get-started-index-add-fein"
    }, {
      path: "add-payroll-worker",
      component: _20a93de5,
      name: "payroll-activation-get-started-index-add-payroll-worker"
    }, {
      path: "add-payroll-workers",
      component: _16c653bc,
      name: "payroll-activation-get-started-index-add-payroll-workers"
    }, {
      path: "add-training-workers",
      component: _4a27f16e,
      name: "payroll-activation-get-started-index-add-training-workers"
    }, {
      path: "authorization",
      component: _54d4fe0a,
      name: "payroll-activation-get-started-index-authorization"
    }, {
      path: "bambee-plus-outro",
      component: _06bd76b2,
      name: "payroll-activation-get-started-index-bambee-plus-outro"
    }, {
      path: "business-location",
      component: _7a65287e,
      name: "payroll-activation-get-started-index-business-location"
    }, {
      path: "confirm-account-info",
      component: _5260245c,
      name: "payroll-activation-get-started-index-confirm-account-info"
    }, {
      path: "current-payroll",
      component: _2c5b0532,
      name: "payroll-activation-get-started-index-current-payroll"
    }, {
      path: "forward",
      component: _faa26e84,
      name: "payroll-activation-get-started-index-forward"
    }, {
      path: "how-to-time-attendance",
      component: _03c3937a,
      name: "payroll-activation-get-started-index-how-to-time-attendance"
    }, {
      path: "how-to-use-training",
      component: _7578b38e,
      name: "payroll-activation-get-started-index-how-to-use-training"
    }, {
      path: "legal-address",
      component: _ce3acf7a,
      name: "payroll-activation-get-started-index-legal-address"
    }, {
      path: "mailing-address",
      component: _7d515371,
      name: "payroll-activation-get-started-index-mailing-address"
    }, {
      path: "payroll-confirmation",
      component: _6c4b577a,
      name: "payroll-activation-get-started-index-payroll-confirmation"
    }, {
      path: "payroll-outro",
      component: _027d4a40,
      name: "payroll-activation-get-started-index-payroll-outro"
    }, {
      path: "setup-payroll",
      component: _26c9a32e,
      name: "payroll-activation-get-started-index-setup-payroll"
    }, {
      path: "time-and-attendance",
      component: _400bd6b8,
      name: "payroll-activation-get-started-index-time-and-attendance"
    }, {
      path: "time-and-attendance-outro",
      component: _11b1feb4,
      name: "payroll-activation-get-started-index-time-and-attendance-outro"
    }, {
      path: "training-outro",
      component: _743974c2,
      name: "payroll-activation-get-started-index-training-outro"
    }, {
      path: "welcome-to-payroll",
      component: _7f07f9ce,
      name: "payroll-activation-get-started-index-welcome-to-payroll"
    }, {
      path: "welcome-to-training",
      component: _1452ff02,
      name: "payroll-activation-get-started-index-welcome-to-training"
    }]
  }, {
    path: "/payroll-setup/connect-provider",
    component: _d12e19e8,
    name: "payroll-setup-connect-provider"
  }, {
    path: "/payroll-setup/provider-confirmation",
    component: _0dd5325d,
    name: "payroll-setup-provider-confirmation"
  }, {
    path: "/privacy/privacy",
    component: _095da19c,
    name: "privacy-privacy"
  }, {
    path: "/settings/add-payment-method",
    component: _49c82c3b,
    name: "settings-add-payment-method"
  }, {
    path: "/settings/billing-history",
    component: _0767de6a,
    name: "settings-billing-history"
  }, {
    path: "/settings/payment-methods",
    component: _7b49cff4,
    name: "settings-payment-methods"
  }, {
    path: "/upgrade/benefits",
    component: _2765cd44,
    name: "upgrade-benefits"
  }, {
    path: "/upgrade/payroll",
    component: _089d8566,
    name: "upgrade-payroll"
  }, {
    path: "/upgrade/report-cards",
    component: _31e80ddc,
    name: "upgrade-report-cards"
  }, {
    path: "/upgrade/requests",
    component: _6cc08a4c,
    name: "upgrade-requests"
  }, {
    path: "/upgrade/time-and-attendance",
    component: _483f1ac7,
    name: "upgrade-time-and-attendance"
  }, {
    path: "/upgrade/voices",
    component: _8d45f4ee,
    name: "upgrade-voices"
  }, {
    path: "/onboarding/employer/index.ai",
    component: _26ece9e8,
    name: "onboarding-employer-index.ai"
  }, {
    path: "/document/job-description/:id?",
    component: _2161a298,
    name: "document-job-description-id"
  }, {
    path: "/document/reaffirm/:id?",
    component: _7db84c60,
    name: "document-reaffirm-id"
  }, {
    path: "/guidance/detail/:id?",
    component: _7840b9d7,
    children: [{
      path: "",
      component: _481d7d18,
      name: "guidance-detail-id"
    }]
  }, {
    path: "/insurance/plans/:planId?",
    component: _7a97bcc4,
    name: "insurance-plans-planId"
  }, {
    path: "/policy/details/:id?",
    component: _52bd90e0,
    name: "policy-details-id"
  }, {
    path: "/qna/by-type/:type?",
    component: _10451dac,
    name: "qna-by-type-type"
  }, {
    path: "/requests/detail/:id?",
    component: _33cffd7a,
    children: [{
      path: "",
      component: _781847e0,
      name: "requests-detail-id"
    }, {
      path: "conversation",
      component: _56427565,
      name: "requests-detail-id-conversation"
    }, {
      path: "files",
      component: _459a181b,
      name: "requests-detail-id-files"
    }]
  }, {
    path: "/create-request/:id?",
    component: _3787629e,
    name: "create-request-id"
  }, {
    path: "/document/:id?",
    component: _43d485bb,
    name: "document-id"
  }, {
    path: "/file/:id?",
    component: _a6e020c8,
    name: "file-id"
  }, {
    path: "/get-started/:slug?",
    component: _2839766f,
    name: "get-started-slug"
  }, {
    path: "/goal/:name",
    component: _047b641f,
    name: "goal-name"
  }, {
    path: "/hr-intelligence/:id?",
    component: _932caa30,
    name: "hr-intelligence-id"
  }, {
    path: "/meetings/:id",
    component: _327abc8a,
    name: "meetings-id"
  }, {
    path: "/pip/:document_id?",
    component: _99770426,
    children: [{
      path: "",
      component: _afb7c2a0,
      name: "pip-document_id"
    }]
  }, {
    path: "/policy-preview/:id",
    component: _3b51e30d,
    name: "policy-preview-id"
  }, {
    path: "/qna/:id?",
    component: _475a14aa,
    name: "qna-id"
  }, {
    path: "/report-cards/:id?",
    component: _52b70eac,
    children: [{
      path: "",
      component: _77199f78,
      name: "report-cards-id"
    }, {
      path: "details",
      component: _a0bc0670,
      name: "report-cards-id-details"
    }]
  }, {
    path: "/settings/:page?",
    component: _2ba1bdae,
    name: "settings-page"
  }, {
    path: "/verbal-warning/:document_id?",
    component: _364d60de,
    children: [{
      path: "",
      component: _34962554,
      name: "verbal-warning-document_id"
    }]
  }, {
    path: "/written-warning/:document_id?",
    component: _a1b97204,
    children: [{
      path: "",
      component: _0d521701,
      name: "written-warning-document_id"
    }]
  }, {
    path: "/insurance/:planId/sign-bor",
    component: _020d3c6a,
    name: "insurance-planId-sign-bor"
  }, {
    path: "/policy/:id/document-preview",
    component: _64d4e723,
    name: "policy-id-document-preview"
  }, {
    path: "/policy/:id/preview",
    component: _25b4ef6a,
    name: "policy-id-preview"
  }, {
    path: "/",
    component: _5c7375ad,
    name: "index"
  }, {
    path: "/about-bambee/payment",
    alias: "/payment"
  }, {
    path: "/about-bambee/payment-confirm",
    alias: "/payment/confirm"
  }, {
    path: "/about-bambee/payment",
    alias: "/payment-offer"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
